import styled from 'styled-components';

export const MainContainer = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 0.75rem;

  .grid-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }
`;

export const PageTitle = styled.h1`
  font-size: 1.475rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-align: center;
`;
